import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Big3Common } from '../../../js/IncludeManager';
import { ComPhoto, NoResult } from "../../../js/ComponentManager";
/* 개발담당:양유빈
 * 화면기능:소매상세정보
 * 세부설명:
*/

export class RtiDtlAp extends Component {
    static displayName = RtiDtlAp.name;
    constructor(props) {
        super(props);
        this.state = {
            RetailInfo:[]
        };
        this.Union_Uid = "";
    }
    //초기화
    componentDidMount() {
        this.CallRetailInfoData();
    }
    async CallRetailInfoData() {
        try {
            Big3Common.Util.LoadingOn();
            if (this.props.ContentState !== undefined && this.props.ContentState !== null) {

                this.Union_Uid = this.props.ContentState.Union_Uid;
                const Model = { union_uid: this.Union_Uid, appr_status: "AP" }
                let Data = await Big3Common.Post("api/Retail/MyRetail/GetRetailInfo", Model);
                if (Data.codeName === Big3Common.ResultCode.Success) {
                    let RetailInfo = JSON.parse(Data.dataTable);
                    this.setState({ RetailInfo: RetailInfo });
                }
                else {
                    console.log(Data.message);
                }
            }
        }
        catch (e) {
            console.log("CallRetailInfoData: ", e)
        }
        finally {
            Big3Common.Util.LoadingOff();
        }
        return false;
    }
    render() {
        if (this.state.RetailInfo.length > 0) {
            let Retail = this.state.RetailInfo[0];
            let address1 = Retail.retail_addr_1 === null ? "" : Retail.retail_addr_1;
            let address2 = Retail.retail_addr_1 === null ? "" : Retail.retail_addr_2;
            return (
                <div className="container_box d_padding p_margin">
                    <div className="retail_info">
                        <div className="retail_photo_box">
                            <ComPhoto className="retail_photo" Photo={Retail.retail_photo} />
                        </div>
                        <div className="retail_order_info">
                            <div className="retail_name">{Retail.retail_org_name}</div>
                            <div className="retail_info_txt retail_add">{Retail.retail_area_nm}</div>
                            <div className="retail_info_txt">누적 주문건수 :  {Big3Common.Util.Money(Retail.mon_ordnumber)}건</div>
                            <div className="retail_info_txt">누적 주문금액  : {Big3Common.Util.Money(Retail.mon_trunover)}원</div>
                            <Link to={`/Order/LiveChat/Index?union_uid=${this.Union_Uid}`}>
                                <div className="chat_icon"></div>
                            </Link>
                            
                        </div>
                    </div>
                    <div className="business_info_box">
                        <div className="business"><div className="business_number_icon"></div><div className="business_title">사업자번호</div></div>
                        <div className="business_info">{Retail.retail_org_no}</div>
                    </div>
                    <div className="business_info_box">
                        <div className="business"><div className="business_address_icon"></div><div className="business_title">사업자주소</div></div>
                        <div className="business_info">{address1 + " " + address2}</div>
                    </div>
                    <div className="retail_btn">
                        <button type="button" className="r_btn_v btn_v1" onClick={() => this.props.RenderComponent('DealHistory', this.props.ContentState)}>거래내역</button>
                    </div>
                </div>
            );
        }
        else {
            return (

                <NoResult
                    Visible={this.state.RetailInfo.length === 0 ? true : false}
                    Top={"40%"}
                />
            )
        }
        
    }
}
